import { useParams } from "react-router-dom";
import ChatsPlaceholder from "./ChatsPlaceholder";

const ChatView: React.FC = () => {
  const { conversationId } = useParams<{ conversationId: string }>();

  return (
    <ChatsPlaceholder
      mobileConversationId={conversationId ? Number(conversationId) : undefined}
    />
  );
};

export default ChatView;
